export enum RequestResultsType { Approver, Requestor }